import * as React from 'react';
import Button from "storybookComponents/Button"
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Field from "content/Campgain/ScheduleInvite/multiTagField.js"


const EmailReport = ({ classes, onClose }) => {
  const [values, setValues] = React.useState({
    pdf: true,
    csv: true,
    emails: []
  })

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.checked
    })
  }

  const setFieldValue = (keyName, emails) => {
    setValues({
      ...values,
      emails
    })
  }

  return <div>
    <div className={classes.header}>Please enter the detailed below to email this Report.</div>
    <FormControlLabel control={<Checkbox checked={values.pdf} name="pdf" onChange={handleChange} />} label="PDF" /><br />
    <FormControlLabel control={<Checkbox checked={values.csv} name="csv" onChange={handleChange} />} label="CSV" /><br />
    <div className={classes.subtitle}>Select atleast one format</div>
    <Field values={values} setFieldValue={setFieldValue} placeholder="example@example.com" keyName="emails" label="Email Address" className={{
      container: classes.emailFieldContainer,
      label: classes.label
    }} />
    <div className={classes.bottomFlexBox}>
      <Button className={classes.btnStyle} variant="tertiary" onClick={onClose}>Cancel</Button>
      <Button className={classes.btnStyle} state={((!values.pdf && !values.csv) || values.emails.length == 0) ? "inactive" : "active"} onClick={onClose}>Send</Button>
    </div>
  </div>
}

export default EmailReport


